module.exports = __webpack_public_path__ + "img/aboutUs01.e7a512b2.svg";